import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Icon, { GLYPHS } from './icon';

const Drawer = ({
  onClose,
  children,
  visible,
}) => (
  ReactDOM.createPortal((
    <div display-if={visible} id="c-drawer">
      <div className="c-overlay c-overlay--fadein" onClick={onClose} />
      <div className="c-drawer u-color-white">
        <div className="c-drawer-close" onClick={onClose} data-automation-id="drawer-close-button">
          <Icon glyph={GLYPHS.closeBtn} size="nano" />
        </div>
        <div className="c-drawer-content">
          {children}
        </div>
      </div>
    </div>
  ), document.body));

Drawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Drawer;
